/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
// import { useMutation, useLazyQuery } from "@apollo/client";
// import ReactTooltip from 'react-tooltip';
import { getXmppToken, openCallWindow } from '../../../Utils/Common';
import { useDispatch } from 'react-redux';
import { set_callringpopup } from '../../../redux/messageSlice';
import answerIcon from '../../../media/images/call/answer_64px.png';
import mergeIcon from '../../../media/images/call/call_merge.png';
import hangupIcon from '../../../media/images/call/hang-up_56px.png';
import MessageIcon from '../../../media/images/call/message_56px.png';
import { useLazyQuery } from '@apollo/client';
import { GET_CALLING_ACCEPT, GET_CALLING_REJECT, JITSI_CALL_MERGE } from '../../../services/apollo/Queries';

window.timer1 = 0;
// let voip_channel = new BroadcastChannel('voip_channel');

// const ring_audio = new Audio('https://wfss001.freeli.io/common/simple_corporate_tone.mp3');
// const ringToneUrl = 'https://wfss001.freeli.io/common/simple_corporate_tone.mp3';

function CallRinging({ user: me, callringpopup: data }) {
    // const { callringpopup: data } = useSelector(state => state.message)
    console.log('CallRinging data:', data, me);
    const dispatch = useDispatch();

    const [getCallingAccept] = useLazyQuery(GET_CALLING_ACCEPT);
    const [getCallingReject] = useLazyQuery(GET_CALLING_REJECT);
    const [getCallingMerge] = useLazyQuery(JITSI_CALL_MERGE);


    useEffect(() => {
        const ring_audio = window.ring_tone;
        ring_audio.loop = true; // Ensures ringtone plays continuously
        ring_audio.volume = 1.0; // Adjust volume if necessary
        // const playSound = async () => {
        //     try {
        //         if (window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
        //             await navigator.mediaDevices.getUserMedia({ audio: true });
        //         }
        //         await ringTone.play(); // Try to play the ringtone
        //     } catch (error) {
        //         console.warn("Autoplay blocked or error playing ringtone:", error);
        //     }
        // };

        window.timer1 = setTimeout(() => {
            // ReactTooltip.hide();
            closeRingWindow();
        }, 60000);

        if (window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
            navigator.mediaDevices.getUserMedia({ audio: true }).then((rstream) => {

                // let ring_audio = document.getElementById('ring_audio_' + data.ring_index);
                if (ring_audio) ring_audio.play();
                rstream.getTracks().forEach((track) => track.stop());
            });
        } else {
            // let ring_audio = document.getElementById('ring_audio_' + data.ring_index);
            if (ring_audio) ring_audio.play();
            alert('call not supported.');
        }
        return () => {
            ring_audio.pause(); // Stop the ringtone when the component unmounts
            ring_audio.currentTime = 0; // Reset audio playback position
        };
    }, []);

    const closeRingWindow = () => {
        const ring_audio = window.ring_tone;
        clearTimeout(window.timer1);
        // let ring_audio = document.getElementById('ring_audio_' + data.ring_index);
        if (ring_audio) ring_audio.pause();
        // console.log('Call window closed');
        dispatch(set_callringpopup({ status: false }));
    };

    // function openCallWindow(conversation_id, jwt_token) {
    //     var ww = window.screen.availWidth * 0.8;
    //     var hh = window.screen.availHeight * 0.8;
    //     var left = (window.screen.width / 2) - (ww / 2);
    //     var top = (window.screen.height / 2) - (hh / 2);

    //     // window.name = "parent";
    //     window.win_voip = window.open("", 'calling_' + conversation_id, "width=" + ww + ",height=" + hh + ', top=' + top + ', left=' + left);

    //     // Listen for the "ready" event from the child
    //     voip_channel.addEventListener('message', (event) => {
    //         debugger;
    //         if (event.data && event.data.type === 'ready') {
    //             console.log("Child window is ready, sending token...");
    //             voip_channel.postMessage({ type: 'jitsi_token_pass', jwt_token });
    //         }
    //     });

    //     if (conversation_id && window.win_voip && window.win_voip.location) {
    //         if (window.win_voip.location.href === 'about:blank') window.win_voip.location.href = '/call/' + conversation_id;
    //         return window.win_voip;
    //     }
    //     // clean_timer_user();
    // }
    const callAcceptBtn = async () => {
        // ReactTooltip.hide();
        // debugger
        // console.log('Call accepted:', data.conversation_id);
        closeRingWindow();
        openCallWindow(data.conversation_id, data.jwt_token, me);

        let apires = await getCallingAccept({
            variables: {
                user_id: data.user_id,
                conversation_id: data.conversation_id,
                token: getXmppToken(),
                type: 'accept',
                device_type: 'web'
            },
            fetchPolicy: 'network-only',
        });
        // let cb_data = apires?.data?.jitsi_call_accept;
        // if (cb_data.status === true) {
        //     localStorage.setItem("jitsi_token", cb_data.jwt_token);
        // }


    };
    const callRejectBtn = async () => {
        // debugger;
        // setCallRinging(false);
        // ReactTooltip.hide();
        closeRingWindow();
        await getCallingReject({
            variables: {
                user_id: data.user_id,
                user_fullname: data.user_fullname,
                conversation_id: data.conversation_id,
                msg_code: 0,
                token: getXmppToken(),
                type: "hangup"

            },
            fetchPolicy: 'network-only',
        });

    };
    // const callHoldBtn = () => {
    //     // ReactTooltip.hide();
    //     closeRingWindow();
    //     // console.log('Call held:', data.conversation_id);
    // };

    const mergeCallBtn = () => {
        const ring_audio = window.ring_tone;
        // ReactTooltip.hide();
        // closeRingWindow();
        // console.log('Call merged:', data.conversation_id);
        if (Object.keys(data.call_merge).length > 1) {
            // props.setPopup({type:'mergeconvpopup', data: true});
            closeRingWindow()
        } else {
            clearTimeout(window.timer1);
            // let ring_audio = document.getElementById('ring_audio_' + data.ring_index);
            if (ring_audio) ring_audio.pause();
            dispatch({ type: 'set_callringpopup', payload: { status: false } });
            dispatch({ type: 'busy_call_msg', payload: false });
            // props.setPopup({type:'voipHoldMute', data: false});
            // props.setPopup({type:'mergeconvpopup', data: false});
            closeRingWindow();
            var logindata = null; logindata = localStorage.getItem('logindata'); if (logindata) logindata = JSON.parse(logindata);

            getCallingMerge({
                variables: {
                    user_id: data.user_id,
                    conversation_id: data.user_busy, // current conv_id for single merge
                    merge_id: data.caller_id, // from jitsi_ring_send
                    conv_id_old: data.conversation_id, // from jitsi_ring_send
                    token: getXmppToken(),
                    // user_fullname: logindata.user.firstname, // new
                    // user_img: logindata.user.img, // new
                    // user_email: logindata.user.email,

                },
                fetchPolicy: 'network-only',
            });

            // voip_send_msg('jitsi_call_merge', {
            //     user_id: me.id,
            //     conversation_id: data.user_busy, // current conv_id for single merge
            //     merge_id: data.caller_id, // from jitsi_ring_send
            //     conv_id_old: data.conversation_id, // from jitsi_ring_send
            //     token: getXmppToken(),
            //     // user_fullname: logindata.user.firstname, // new
            //     // user_img: logindata.user.img, // new
            //     // user_email: logindata.user.email,

            // });


        }
    };

    const CallBusyMsg = () => {
        // ReactTooltip.hide();
        // console.log('Busy message sent');
    };

    return (
        <>
            <div className="backwrapCall">
                <div id={`ring_div_${data.ring_index}`} className="myCallModal" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <img className="calling_userimg" src={data.caller_img} alt="Caller" title='Caller' />
                                <p className="modalCallMsg">{data.caller_name}</p>
                                <p className="modal_incomingcall">INCOMING CALL</p>
                                <p className="modal_callstatus">Ringing...</p>
                                {/* <audio id={`ring_audio_${data.ring_index}`} className="mdCallRingtone call_ringtone_audio" playsInline autoPlay src="https://wfss001.freeli.io/common/simple_corporate_tone.mp3" controls loop></audio> */}
                            </div>
                            <div className="modal-footer">
                                <div className="mergeBtnGroup">
                                    <img title='Reject Call' alt="Reject Call" src={hangupIcon} className="modalCallReject" onClick={callRejectBtn} />
                                    <img title='Accept Call' alt="Accept Call" src={answerIcon} className="modalCallAccept" onClick={callAcceptBtn} />
                                    {data.user_busy ?
                                        <>
                                            {Object.keys(data.call_merge).length ?
                                                <img title='Merge Call' data-tip="Merge Call" src={mergeIcon} className="modalCallAccept" onClick={mergeCallBtn} alt="Merge Call" /> : ''}
                                            {/* <img title='Hold & Accept Call' alt="Hold & Accept Call" src="/media/images/call/answer_64px.png" className="modalCallAccept" onClick={callHoldBtn} /> */}
                                        </>
                                        :
                                        ''
                                    }
                                    <img title='Reject Message' alt="Reject Message" src={MessageIcon} className="modalCallTextMsg" onClick={CallBusyMsg} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CallRinging;
